import type {SmsAction} from 'src/action-creators/sms';
import type {SmsState} from 'src/types/sms';
import type {NodeAlert} from 'src/types/node-alert';
import uniqueId from 'lodash/uniqueId';

import {
  RECEIVE_SMS_INFO,
  UPDATE_SMS_INFO,
  UPDATE_NODE_SCHEDULE,
  UPDATE_NOTE_WRITEBACK,
  RESET,
  ADD_ALERT,
  REMOVE_ALERT,
  SET_ALERT_TO,
  SET_ALERT_RULES,
} from 'src/action-creators/sms';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {getMessagingDefaultNoteWritebackState} from 'src/utils/note-writeback';
import {createFilterBlockIdentifier} from 'src/utils/filter';
import {getDefaultUtmConfigState} from 'src/utils/utm-config';


const initialState = {
  to_number: null,
  from_number: null,
  external_source_id: null,
  category_id: null,
  body: ``,
  sender_category: null,
  surveysAttached: [],
  meetingsAttached: [],
  alerts: [],
  ...getMessagingDefaultNoteWritebackState(),
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
  ...getDefaultUtmConfigState(),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly date_type?: string; readonly date_value?: string; readonly time_type?: string; readonly time_value?: string; readonly offset?: number; readonly date_field?: string | null | undefined; ... 14 more ...; readonly surveysAttached: readonly []; }' is not assignable to type 'SmsState'.
  state: SmsState = initialState,
  action: SmsAction,
): SmsState => {
  switch (action.type) {
    case UPDATE_SMS_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_SMS_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NOTE_WRITEBACK:
      return {
        ...state,
        ...action.payload,
      };
    case ADD_ALERT: {
      const {rules, response_key} = action.payload;
      const alert: NodeAlert = {
        id: uniqueId('alert'),
        template_name: null,
        template_id: null,
        blocks: new Map([
          [createFilterBlockIdentifier(), {rules, scope: null}],
        ]),
        to: null,
        response_key,
      };
      return {
        ...state,
        alerts: [...(state.alerts ?? []), alert],
      };
    }
    case REMOVE_ALERT: {
      const {id} = action.payload;
      return {
        ...state,
        alerts: (state.alerts ?? []).filter((a) => a.id !== id),
      };
    }
    case SET_ALERT_TO: {
      const {id, to} = action.payload;
      return {
        ...state,
        alerts: (state.alerts ?? []).map((a) => (a.id === id ? {...a, to} : a)),
      };
    }
    case SET_ALERT_RULES: {
      const {id, blockId, rules} = action.payload;
      return {
        ...state,
        alerts: (state.alerts ?? []).map((a) => {
          if (a.id !== id) {
            return a;
          }
          const updatedBlocks = new Map(a.blocks);
          const currentEntry = updatedBlocks.get(blockId);
          if (currentEntry) {
            updatedBlocks.set(blockId, {
              ...currentEntry,
              rules,
              // alerts screen does not use scope
              scope: null,
            });
          }
          return {
            ...a,
            blocks: updatedBlocks,
          };
        }),
      };
    }
    case RESET:
      // @ts-expect-error - TS2322 - Type '{ date_type?: string; date_value?: string; time_type?: string; time_value?: string; offset?: number; date_field?: string | null | undefined; time_field?: string | null | undefined; dateOffset?: Offset; ... 12 more ...; surveysAttached: readonly []; }' is not assignable to type 'SmsState'.
      return {...initialState};
  }
  return state;
};
